import type { ICampaignsScrapingConfiguration } from "app/components/campaigns/shared/CampaignsConst";
import { getDefaultDevice, getLocationsIdsForSelectedCampaign } from "app/components/campaigns/shared/CampaignsUtils";
import { DEFAULT_RT_DURATION, RT_PATH } from "app/pages/activation/components/RankWidget/config";
import type { RTDefaultParams } from "app/pages/activation/components/RankWidget/types";
import type { RTRawFilterParams } from "app/pages/digital-marketing/keywords-campaigns/reports/types";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { GranularityNames } from "app/UtilitiesAndConstants/Constants/Moment";

type GoToRankTrackerPageParams = {
    campaignId: string;
    scrapingConfigurations: ICampaignsScrapingConfiguration[];
    site: string;
    filters?: RTRawFilterParams | Record<string, string>;
    duration?: string;
};

export const openRankTrackerPage = ({
    campaignId,
    scrapingConfigurations,
    duration = DEFAULT_RT_DURATION,
    site,
    filters = {},
}: GoToRankTrackerPageParams): void => {
    const device = getDefaultDevice(scrapingConfigurations);
    const locationsIds = getLocationsIdsForSelectedCampaign(scrapingConfigurations, device).split("&")[0];

    const { graphTab, tableTab, sortedColumn, asc, serpFilterGroup, positionGroup, sort } =
        (proNavigator.getState(RT_PATH)?.defaultQueryParams as RTDefaultParams) ?? {};

    const href = proNavigator.href(RT_PATH, {
        ...filters,
        campaignId,
        duration,
        locationsIds,
        device,
        tableGranularity: GranularityNames.DAILY,
        graphGranularity: GranularityNames.DAILY,
        sites: site,
        graphTab,
        tableTab,
        sortedColumn,
        asc,
        serpFilterGroup,
        positionGroup,
        sort,
    });

    window.open(href, "_blank");
};
